import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {get} from '../Storage';


var AppSettings = get();
var componentName = AppSettings.appId + 'LoyaltySystemBadgeComponent';

var styles = AppSettings.styles;

class LoyaltySystemBadge extends React.Component
{
    constructor(props) {
        super(props);
        this.state = {
            balance: null,
            status: null,
            errors: [],
            showLoading: true
        }

        this.openLoyaltySystemPage = this.openLoyaltySystemPage.bind(this);
        this.loadLoyaltySystem = this.loadLoyaltySystem.bind(this);
    }

    componentDidMount() {
        this.loadLoyaltySystem();
    }

    loadLoyaltySystem(){
       
        let url = AppSettings['env'].urlUserBoxLoyaltySystem;
        axios.get(url)
            .then(({ data}) => {
                if (data.errors.length == 0) {
                    this.setState({
                        showLoading: false,
                        balance: data.balance, 
                        status: data.status,
                        errors: []
                    });
                } else {
                    this.setState({
                        showLoading: false,
                        balance: null,
                        status: null,
                        errors: data.errors,
                    });
                }
            })
            .catch(() => {
                this.setState({
                    showLoading: false,
                    balance: null,
                    status: null,
                    errors:[
                        {
                            "code": 200,
                            "internalMessage": "Error catch UserBoxLoyaltySystem",
                            "moreInfo": null,
                            "userMessage": "Si è verificato un errore inaspettato"
                        }
                    ]
                });
            });
    }


    openLoyaltySystemPage(e){
        e.stopPropagation();
        e.preventDefault();
        if(AppSettings['loyaltysystemurl'] != null && AppSettings['loyaltysystemurl'] != ""){
            location.href = AppSettings['loyaltysystemurl'];
        }
    }



    render() {
        return(
            <React.Fragment>
                {!this.state.showLoading && this.state.errors.length ==  0 ?
                    <div id="ub-loyaltysystem">
                        <div>
                            <span className="ub-loyaltysystem--title">Punti fedeltà</span>
                            <span className="ub-loyaltysystem--points">{this.state.balance.points}</span>
                        </div>
                        <img src="/l.ashx?s=default&u=default/loyaltysystem/icon-points.png" alt="Programma fedeltà"/>
                        <i className="ub-loyaltysystem--link" title="Programma fedeltà" onClick={this.openLoyaltySystemPage}></i>
                    </div> : ""
                }
            </React.Fragment>
        );
    }
}

LoyaltySystemBadge.displayName = componentName;

// PropTypes validation
LoyaltySystemBadge.propTypes = {
};

// default props
LoyaltySystemBadge.defaultProps = {
};


LoyaltySystemBadge.contextTypes = {
    openLinkPopup: PropTypes.func
}
export default LoyaltySystemBadge;